import 'core-js/proposals/reflect-metadata';

import { Serializable, jsonProperty } from 'ts-serializable';
import UserAddress from '../UserAddress';

class Unit extends Serializable {

    @jsonProperty(String, null)
    id: string = '';

    @jsonProperty(Boolean)
    inativo: boolean = false;

    @jsonProperty(String, null)
    nomeFantasia: string = '';

    @jsonProperty(Boolean, null)
    usaClinicFrame: boolean = false;

    @jsonProperty(String, null)
    clinicFrameUrl: string = '';
    
    @jsonProperty(String, null)
    clinicFrameApiUrl: string = '';

    @jsonProperty(String, null)
    cnpj: string = '';

    @jsonProperty([String], null)
    telefones: string[] | null = [];

    @jsonProperty(UserAddress)
    endereco: UserAddress = new UserAddress();

}

export default Unit;